import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTrigger,
  Field,
  Input,
  Spinner,
} from "@fluentui/react-components";
import React, { useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import FormikInputRequest from "../../service/hook/useFormik";
import apiServices from "../../service";
import { AppDispatch } from "../../redux/store";
import { useDispatch } from "react-redux";
import { resetFormData } from "../../redux/reducer";
import { FormErrorMessage } from "../FormErrorMessage/FormErrorMessage";
import { updateAssociatedWith } from "../../redux/activeClientSlice";
import { useParams } from "react-router-dom";
import {
  getAssetDetailById,
  getAssetListItems,
} from "../../redux/Case/assetSlice";
import {
  getLiabilityDetailById,
  getLiabilityListItems,
} from "../../redux/Case/liabilitySlice";
import { LIABILITY_CASE_TYPE_MAP } from "../../pages/client/case/Liability/LiabilityHomePage";
import {
  getPolicyDetailById,
  getPolicyListItems,
} from "../../redux/Case/policySlice";
import { POLICY_CASE_TYPE_MAP } from "../../pages/client/case/Policy/PolicyHomePage";
import ASCButton from "../Button";
import { ASSET_CASE_TYPE_MAP } from "../../pages/client/case/Asset/assetSubTypeConfig";

interface Option {
  readonly label: string;
  readonly value: string;
}
const PartnerDetailPopup = (props: any) => {
  const [loading, setLoading] = useState(false);
  const [apiProcessing, setApiProcessing] = useState(false);
  const dispatch: AppDispatch = useDispatch();
  const { clientId, caseId, case_type } = useParams();
  const [value, setValue] = useState<Option | null>();
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [newlyAddedSelectOptions, setNewlyAddedSelectOptions] = useState<any>(
    []
  );
  const createOption = (label: string) => ({
    label,
    value: label,
  });
  const defaultOptions = [createOption("")];
  const [options, setOptions] = useState(defaultOptions);

  const AddSelectOptions = () => {
    if (newlyAddedSelectOptions.length > 0) {
      apiServices.selectionList
        .addOptions(newlyAddedSelectOptions)
        .then((response: any) => {})
        .catch((err) => console.log(err));
    }
  };
  const [selectFieldOptions, setSelectFieldOptions] = useState<any>([]);

  const getSelectionListOptions = async () => {
    try {
      let fieldLbl = "";
      fieldLbl = "title:ModifiableList";
      if (fieldLbl !== "") {
        const res = await apiServices.selectionList.getOptions(fieldLbl);
        if (res.data && res.data.data) {
          setSelectFieldOptions(res.data.data);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const FindOption = () => {
    const foundObject = selectFieldOptions.find(
      (obj: any) => obj.field === "title"
    );
    if (foundObject !== undefined) setOptions(foundObject.options);
  };
  useEffect(() => {
    FindOption();
  }, [selectFieldOptions, "title"]);

  const formikData = FormikInputRequest({
    initialValues: {
      title: "",
      first_names: "",
      last_name: "",
    },
    validate: (values) => {
      const errors: any = {};
      if (!values.last_name) {
        errors.last_name = "Last Name is required";
      }
      return errors;
    },
    onSubmitFn: async (values: any) => {
      try {
        const newData = {
          name_and_address: {
            customer_id: clientId,
            title: values.title,
            first_names: values.first_names,
            last_name: values.last_name,
            client_value: "partner",
          },
        };
        setLoading(true);
        setApiProcessing(true);
        apiServices.client
          .createNew(newData)
          .then((response: any) => {
            setLoading(false);
            setApiProcessing(false);
            if (!response.data.isError) {
              AddSelectOptions();
              setTimeout(() => {
                setIsFormLoading(false);
                props.notify(response.data.message, "", "success");
                props.setPartnerDialogPopup(false);
              }, 1000);
              // dispatch(resetFormData());

              dispatch(updateAssociatedWith(response.data?.data.customer_id));
              if (props.section == "assets" && clientId) {
                dispatch(
                  getAssetListItems({
                    customerId: clientId,
                    caseType: case_type ? ASSET_CASE_TYPE_MAP[case_type] : undefined,
                  })
                );
                if (props.mode == "edit" && caseId) {
                  dispatch(getAssetDetailById({ id: caseId, customerId: clientId }));
                }
              } else if (props.section == "liabilities" && clientId) {
                dispatch(
                  getLiabilityListItems({
                    customerId: clientId,
                    caseType: case_type ? LIABILITY_CASE_TYPE_MAP[case_type] : undefined,
                  })
                );
                if (props.mode == "edit" && caseId) {
                  dispatch(getLiabilityDetailById({ id: caseId, customerId: clientId }));
                }
              } else if (props.section == "policies" && clientId) {
                dispatch(
                  getPolicyListItems({
                    customerId: clientId,
                    caseType: case_type ? POLICY_CASE_TYPE_MAP[case_type] : undefined,
                  })
                );
                if (props.mode == "edit" && caseId) {
                  dispatch(getPolicyDetailById({ id: caseId, customerId: clientId }));
                }
              }

              props.setActivePartnerId(response.data?.data.customer_id);

              props.reloadDetail();
            } else {
              props.notify("Something went wrong", "", "error");
            }
          })
          .catch((error: Error) => {
            setLoading(false);
            setApiProcessing(false);
            console.log("error");
          });
      } catch (error) {
        setApiProcessing(false);
        console.error("Error adding folder:", error);
      }
    },
  });
  const handleCreate = (inputValue: string, name: string) => {
    setLoading(true);
    setTimeout(() => {
      const newOption = createOption(inputValue);
      setLoading(false);
      // setOptions((prev) => [...prev, newOption]);
      setValue(newOption);
      formikData.setFieldValue(name, inputValue);
      if (props.newSelectOptionAdded !== undefined) {
        props.newSelectOptionAdded(name, newOption, "add");
      }
      /* We can add function to add this new value to our option json */
    }, 1000);
  };
  const handleCreateWithParam = (inputValue: string) => {
    handleCreate(inputValue, "title");
  };
  function onChangeValue(key: string, value: any) {
    formikData.setFieldValue(key, value);
  }
  useEffect(() => {
    getSelectionListOptions();
  }, []);
  return (
    <Dialog open={props.partnerDialogPopup} modalType="modal">
      <DialogSurface>
        <DialogBody>
          <DialogContent>
            <div>
              <h3>Add Partner Details</h3>
              <p>
                Please add partner information before adding the details for the
                partner{" "}
              </p>
              {props.formError && props.formError.length > 0 && (
                <FormErrorMessage
                  errorMessages={props.formError}
                  onDismiss={() => props.setFormError([])}
                />
              )}
              <div
                style={{
                  backgroundColor: "#f9f9f9",
                  padding: 10,
                }}
              >
                <Field label="Title">
                  <CreatableSelect
                    name="title"
                    styles={{
                      control: (baseStyles: any, state) => ({
                        ...baseStyles,
                        border: "none",
                        borderColor: state.isFocused ? "grey" : "grey",
                        width: 500,
                      }),
                      menuList: (styles: any) => ({
                        ...styles,
                        maxHeight: 100, // Adjust the maximum height here
                        overflowY: "auto", // Add scrollbar if needed
                      }),
                    }}
                    isClearable
                    isLoading={loading}
                    options={options}
                    onChange={(newValue) => {
                      if (newValue === null) {
                        formikData.setFieldValue("title", "");
                        setValue(null);
                        if (props.newSelectOptionAdded !== undefined) {
                          props.newSelectOptionAdded("title", "", "remove");
                        }
                      }
                      newValue &&
                        formikData.setFieldValue("title", newValue.value);
                      setValue(newValue);
                      if (props.customHandleChange !== undefined) {
                        props.customHandleChange({
                          target: { name: "title", value: newValue?.value },
                        });
                      }
                    }}
                    onCreateOption={handleCreateWithParam}
                    value={value}
                    formatCreateLabel={(inputValue: string) => `${inputValue}`}
                  />
                </Field>
                <Field label="First Name(s)">
                  <Input
                    appearance="outline"
                    type="text"
                    name="first_names"
                    value={formikData.values.first_names}
                    onChange={(e) => {
                      onChangeValue("first_names", e.target.value);
                    }}
                  />
                </Field>
                <Field
                  label={
                    <span>
                      Last Name<span className="required-item">*</span>
                    </span>
                  }
                  validationState={
                    formikData.errors.last_name ? "error" : "none"
                  }
                  validationMessage={`${formikData?.errors?.last_name || ""}`}
                >
                  <Input
                    appearance="outline"
                    type="text"
                    name="last_name"
                    value={formikData.values.last_name}
                    onChange={(e) => {
                      onChangeValue("last_name", e.target.value);
                    }}
                  />
                </Field>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <ASCButton
                shape="rounded"
                appearance="secondary"
                onClick={() => {
                  props.setPartnerDialogPopup(false);
                }}
                label="Close"
              />
            </DialogTrigger>
            <Button
              shape="rounded"
              type="submit"
              appearance="primary"
              className="asc-button-primary"
              onClick={() => {
                if (props.isFormDataUpdated) {
                  formikData.handleSubmit();
                }
              }}
              icon={apiProcessing ? <Spinner size="tiny" /> : null}
            >
              {apiProcessing ? "Processing" : "Submit"}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default PartnerDetailPopup;
